import { useEffect, useRef, useState } from "react";
import { http } from "../lib/api";

export const useNavDots = (nav, pathname, lastEvent) => {
  const [dots, setDots] = useState({});
  const timer = useRef(null);
  const active = nav.find((n) => n.dot && (n.end ? pathname === n.to : pathname.startsWith(n.to)))?.dot;
  const load = () => http.get("/nav/dots").then((r) => setDots(r.data)).catch(() => {});
  useEffect(() => {
    if (active && active !== "messages") http.post("/nav/seen", { key: active }).then(load).catch(() => {});
    else load();
    const iv = setInterval(load, 60000);
    return () => clearInterval(iv);
  }, [active]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (!lastEvent) return;
    clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      if (active && active !== "messages") http.post("/nav/seen", { key: active }).then(load).catch(() => {});
      else load();
    }, 1500);
  }, [lastEvent]); // eslint-disable-line react-hooks/exhaustive-deps
  return { ...dots, [active]: active === "messages" ? dots.messages : false };
};

export const NavDot = ({ k }) => (
  <span data-testid={`nav-dot-${k}`} title="Nouveaux éléments" className="ml-1.5 h-2.5 w-2.5 rounded-full bg-rose-600 ring-2 ring-rose-200 animate-pulse shrink-0" />
);
